module.exports = __webpack_public_path__ + "8c9ed395785f3033740b1b0ac556d131.svg";


//////////////////
// WEBPACK FOOTER
// ./~/clarity-ui/dist/fonts/open-sans-extrabold.svg
// module id = 1531
// module chunks = 0